import API from '../../sunwiseAPI';
const ENTITY = 'cups-historical';

export const getCupsInfoByDate = ({ cups, final_date, initial_date, rate }) =>
    API.get(`/api/v1/${ENTITY}/sunpay/`, {
        params: { cups, initial_date, final_date, rate },
    });
